import * as yup from 'yup';
const planPickerSchema = yup
    .object()
    .shape({
    plan: yup.lazy((val) => !val
        ? yup.string().nullable().notRequired()
        : yup
            .string()
            .oneOf([
            'basic',
            'basic-extended-trial',
            'annual',
            'commitment-monthly-12months',
            'commitment-monthly-24months',
            'biannual',
            'unlimited-free',
            'legacy-unlimited-free',
            'new-bundle-1-year',
            'new-bundle-2-year',
            'new-bundle-3-year',
            'annual-monthly',
            'annual-prepaid-1-year',
            'annual-prepaid-2-year',
            'annual-prepaid-3-year',
            'flexible-monthly'
        ], 'Invalid plan'))
})
    .defined();
export default planPickerSchema;
